import { usePresenceChannel } from "./presence";

/**
 * Mounts the single record-presence channel for the authenticated app surface and renders
 * nothing. Mounted inside `<RealtimeProvider>` (so it reads the shared connection from
 * context) and outside any route — the same placement and rationale as
 * <c>QueueRealtimeBridge</c>: presence runs on one connection servicing every route, and the
 * heartbeat/TTL timers and roster store must not be torn down and rebuilt on navigation.
 *
 * Per-record join/watch is acquired by the feature hooks (`useRecordPresence` /
 * `useObservedRecordPresence`); this bridge only services the connection.
 */
export function PresenceChannelBridge(): null {
    usePresenceChannel();
    return null;
}
